import {
  AB_TEST_METRIC_DISPLAY_MODE_ATTRIBUTION,
  AB_TEST_METRIC_DISPLAY_MODE_IP,
} from '@/utils/abtestMetricDisplay';

// A/B 测试在开启归因窗口后，需要把归因指标固定展示在 signupRate 后面。
const AB_ATTRIBUTION_METRICS = ['orderGmv', 'orderCntNew', 'orderAtv'];
const AB_IP_ONLY_METRICS = ['orderRate', 'orderCnt'];

export const normalizeAbtestMeasures = (
  measures: string[] = [],
  metricDisplayMode?: string | null,
  fallbackAttribution = false
) => {
  // 存量实验 metricDisplayMode 可能为空，此时沿用外层灰度结果决定默认口径。
  const isAttributionMode = metricDisplayMode === AB_TEST_METRIC_DISPLAY_MODE_ATTRIBUTION;
  const isIpMode = metricDisplayMode === AB_TEST_METRIC_DISPLAY_MODE_IP || (!metricDisplayMode && !fallbackAttribution);
  const shouldUseAttributionMetrics = isAttributionMode || (!metricDisplayMode && fallbackAttribution);

  // 先按当前实验口径剔除不应展示的指标，避免用户历史保存的列残留。
  const nextMeasures = isAttributionMode
    ? measures.filter((metric) => !AB_IP_ONLY_METRICS.includes(metric))
    : isIpMode
      ? measures.filter((metric) => !AB_ATTRIBUTION_METRICS.includes(metric))
      : [...measures];
  const currentAttributionMetrics = AB_ATTRIBUTION_METRICS
    .filter((metric) => nextMeasures.includes(metric));
  const shouldReorderAttributionMetrics = shouldUseAttributionMetrics
    && nextMeasures.includes('signupRate')
    && currentAttributionMetrics.length > 0;

  if (!shouldReorderAttributionMetrics) {
    return nextMeasures;
  }

  const signupRateIndex = nextMeasures.indexOf('signupRate');
  // 仅重排当前仍被用户保留的归因指标，不自动补回已删除的列。
  const filteredMeasures = nextMeasures.filter((metric) => !AB_ATTRIBUTION_METRICS.includes(metric));
  filteredMeasures.splice(signupRateIndex + 1, 0, ...currentAttributionMetrics);
  return filteredMeasures;
};
